export default "__VITE_ASSET__4a24a37c__"